import { render, staticRenderFns } from "./ExistingCategories.vue?vue&type=template&id=21faafa6&scoped=true"
import script from "./ExistingCategories.vue?vue&type=script&lang=ts"
export * from "./ExistingCategories.vue?vue&type=script&lang=ts"
import style0 from "./ExistingCategories.vue?vue&type=style&index=0&id=21faafa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21faafa6",
  null
  
)

export default component.exports